module.exports = __webpack_public_path__ + "static/media/slider-2.f77e382e.jpg";